import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const EmailVerificationPage = () => {
  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography variant="h4" component="h1" textAlign="center">
        Ihre E-Mail-Adresse wurde erfolgreich verifiziert!
      </Typography>
      <Typography variant="body1" textAlign="center">
        Sie können sich nun mit Ihren Anmeldedaten einloggen.
      </Typography>
      <Button component={Link} to="/pages/login" variant="contained">
        Zum Login
      </Button>
    </Box>
  );
};

export default EmailVerificationPage;
